import { GraphSchema } from '@camelot/server';
import { User } from '@camelot/user';

import { BillingItem, billingItemProps } from '../../../../common/services/dto/item';
import { Quotation } from './quotation';
import { QuotationStatus } from './quotation-status';

export interface QuotationVersion extends BillingItem {
  version: number;
  // projeté par la seule query de détail : absent des versions issues des listes
  documentIds?: string[];
  status: QuotationStatus;
  date: string;
  acceptanceDate: string;
  paymentTerm: string;
  vatLevelId: number | null;

  downloadUriExcel: string;

  rowsMigratedCount: number;
  fullyMigrated: number;

  discount: number;

  hideRowsPrice: boolean;

  quotation?: Quotation;

  canBeSigned: boolean;
}

export interface QuotationVersionExtended extends QuotationVersion {
  devisor?: User;
}

const props: (keyof QuotationVersion)[] = [
  'version',
  'documentIds',
  'status',
  'date',
  'acceptanceDate',
  'paymentTerm',
  'vatLevelId',
  'downloadUriExcel',
  'rowsMigratedCount',
  'fullyMigrated',
  'discount',
  'hideRowsPrice',
  'quotation',
  'canBeSigned',
  'devisorId',
];
export const quotationVersionProps = new GraphSchema<QuotationVersion>(props.concat(billingItemProps));
